import React, { useState } from "react";
import Tooltip from "./tooltip";
import {
  dislikeIconFilled,
  dislikeIconUnfilled,
  likeIconFilled,
  likeIconUnfilled,
} from "./icons-svg";
import store from "src/store";
import CustomModal from "./custom-modal";
import InputTextarea from "./input-textarea";

export default function AIfeedback({
  type,
  submissionText,
  iconDimension = 28,
  showButton = false,
}) {
  const [AIresponseLiked, setAIresponseLiked] = useState(false);
  const [AIresponseDisliked, setAIresponseDisliked] = useState(false);
  const [openAIresponseFeedbackModal, setOpenAIresponseFeedbackModal] =
    useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackTextHasError, setFeedbackTextHasError] = useState(false);
  const [feedbackTextErrorText, setFeedbackTextErrorText] = useState("");
  const [submittingAIfeedback, setSubmittingAIfeedback] = useState(false);

  const onLikeDislikeBtnClick = (response) => {
    if (response) {
      setAIresponseLiked(true);
      setAIresponseDisliked(false);
    } else {
      setAIresponseLiked(false);
      setAIresponseDisliked(true);
    }
    setOpenAIresponseFeedbackModal(true);
  };

  const onSubmitFeedback = async () => {
    if (!feedbackText || (feedbackText && !feedbackText.trim())) {
      setFeedbackTextHasError(true);
      setFeedbackTextErrorText("Please enter some feedback");
    } else {
      setFeedbackTextHasError(false);
      setFeedbackTextErrorText("");
    }
    try {
      setSubmittingAIfeedback(true);
      let response = await store.submitAIfeedback({
        type,
        feedbackText,
        AIresponseLiked,
      });
      console.log("response", response);
      store.showToaster("info", `Thank you! ${submissionText}`);
      setSubmittingAIfeedback(false);
      onCloseFeedbackModal();
    } catch (err) {
      console.log("Some error has occurred while submitting feedback ", err);
    }
  };

  const onCloseFeedbackModal = () => {
    setOpenAIresponseFeedbackModal(false);
    setFeedbackText("");
    setFeedbackTextHasError(false);
    setFeedbackTextErrorText("");
  };

  return (
    <>
      <CustomModal
        size="medium"
        title="Feedback"
        showModal={openAIresponseFeedbackModal}
        onCloseModal={() => {
          onCloseFeedbackModal();
        }}
        submitBtnText={"Submit"}
        onSubmit={() => {
          onSubmitFeedback();
        }}
        submitBtnDisabled={false}
        children={
          <form onSubmit={() => onSubmitFeedback()}>
            <div css="margin-top: 15px;">
              <InputTextarea
                id={"AIresponseFeedback"}
                label={"Please provide additional information"}
                rows={4}
                value={feedbackText}
                disabled={false}
                onChange={(value) => {
                  setFeedbackText(value);
                }}
                hasError={feedbackTextHasError}
                errorText={feedbackTextErrorText}
                autoFocus={true}
              />
            </div>
          </form>
        }
        loading={submittingAIfeedback}
        secondaryRightBtnText={undefined}
        onSecondaryRightBtnSubmit={undefined}
        secondaryBtnLoading={undefined}
      ></CustomModal>

      <div
        css={`
          display: flex;
          margin-bottom: 10px;
        `}
      >
        <div
          css="margin-right: 5px;"
          onClick={() => onLikeDislikeBtnClick(true)}
        >
          {showButton ? (
            <button
              style={{
                display: "flex",
                alignItems: "center",
                opacity: 0.5,
                borderRadius: "8px",
                padding: "5px 10px",
                border: "1px solid #ccc",
                cursor: "pointer",
                backgroundColor: "transparent",
              }}
            >
              {AIresponseLiked
                ? likeIconFilled(iconDimension, 0.5)
                : likeIconUnfilled(iconDimension, 0.5)}
              <span style={{ marginLeft: "5px" }}>Good response</span>
            </button>
          ) : AIresponseLiked ? (
            <Tooltip tip="Liked the AI response">
              {likeIconFilled(iconDimension, 0.5)}
            </Tooltip>
          ) : (
            <Tooltip tip="Like the AI response">
              {likeIconUnfilled(iconDimension, 0.5)}
            </Tooltip>
          )}
        </div>
        <div onClick={() => onLikeDislikeBtnClick(false)}>
          {showButton ? (
            <button
              style={{
                display: "flex",
                alignItems: "center",
                opacity: 0.5,
                borderRadius: "8px",
                padding: "5px 10px",
                border: "1px solid #ccc",
                cursor: "pointer",
                backgroundColor: "transparent",
              }}
            >
              {AIresponseDisliked
                ? dislikeIconFilled(iconDimension, 0.5)
                : dislikeIconUnfilled(iconDimension, 0.5)}
              <span style={{ marginLeft: "5px" }}>Bad response</span>
            </button>
          ) : AIresponseDisliked ? (
            <Tooltip tip="Disliked the AI response">
              {dislikeIconFilled(iconDimension, 0.5)}
            </Tooltip>
          ) : (
            <Tooltip tip="Dislike the AI response">
              {dislikeIconUnfilled(iconDimension, 0.5)}
            </Tooltip>
          )}
        </div>
      </div>
    </>
  );
}
